export default "__VITE_ASSET__DruxWPQq__"